const userDetails = {
  infoCard: {
    countApps: 'Número de aplicaciones',
    payments: 'Pagos',
    spendings: 'Gastos',
    email: 'Correo electrónico',
    id: 'ID',
    currentPlan: 'Plan actual',
    balance: 'Saldo',
    status: 'Estado',
    active: 'Activo',
    registrationDate: 'Fecha de registro',
    lastLogin: 'Último inicio de sesión',
    country: 'País',
    refEmail: 'Referente',
    reflinkId: 'Código de reflink',
    externalParams: 'Parámetros externos',
  },
  editCard: {
    editDetail: 'Editar datos del usuario',
    activateUser: 'Activar usuario',
    resendEmail: 'Reenviar correo electrónico',
    removeUser: 'Eliminar usuario',
    email: 'Correo electrónico',
    phone: 'Teléfono',
    role: 'Rol',
    priceplan: 'Plan de precios',
    manager: 'Gerente',
    refId: 'Enlace de referencia',
    isUserEuPayee: 'El usuario es beneficiario de la UE',
    save: 'Guardar',
    userActivated: 'Usuario activado correctamente',
    userDeleted: 'Usuario eliminado correctamente',
    userChanged: 'Los cambios en los datos del usuario se aplicaron correctamente',
  },
  paymentsTable: {
    userPayments: 'Pagos',
    showing: 'mostrado',
    paymentsOf: 'Pagos de',
    noUserPaymentsFound: 'No se encontraron los pagos del usuario',
  },
  transactionTable: {
    userTransactions: 'Transacciones',
    showing: 'mostrado',
    transactionsOf: 'Transacciones de',
    noUserTransactionsFound: 'No se encontraron las transacciones del usuario',
  },
  referralTable: {
    userReferrals: 'Referencias de usuarios',
    showing: 'mostrando',
    referralsOf: 'referencias de',
    noUserReferralsFound: 'No se encontraron referencias de usuarios',
    addNew: 'Añadir referencia',
    addNewSuccess: 'Referencia añadida correctamente',
  },
  changeBalanceCard: {
    changeBalance: 'Cambiar saldo de usuario',
    amount: 'Importe',
    account: 'Cuenta',
    type: 'Tipo',
    reason: 'Motivo',
    id: 'Identificador único de pago',
    paymentId: 'Identificador de pago',
    generate: 'Generar',
    description: 'Descripción',
    balanceChanged: 'Saldo modificado correctamente',
  },
  reflinksModal: {
    reflinksList: 'Historial de enlaces de referencia',
    name: 'Nombre',
    code: 'Código',
    create: 'Creado',
  },
  externalModal: {
    externalParams: 'Parámetros externos',
    value: 'Valor',
  },
  tableDropdown: {
    exportUserPayments: 'Exportar'
  },
  messagesTable: {
    userMessages: 'Mensajes',
    showing: 'Mostrar',
    recordes: 'registros',
    noUserMessagesFound: 'No se encontraron mensajes de usuario',
  },
};

export default userDetails;
